if (!customElements.get('variant-description')) {
  customElements.define(
    'variant-description',
    class VariantDescription extends HTMLElement {
      constructor() {
        super();
        this.variantChangeUnsubscriber = undefined;
        this.descriptionContainer = null;
        this.sectionId = null;
        this.fallbackDescription = '';
        this.variantMetafields = {}; // Cache for variant metafields
      }

      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.descriptionContainer = document.querySelector(`#variant-description-${this.sectionId}`);

        if (!this.descriptionContainer) {
          return;
        }

        // Store original description as fallback
        this.fallbackDescription = this.descriptionContainer.innerHTML;

        // Subscribe to variant change events
        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          this.handleVariantChange.bind(this)
        );

        // Load variant metafields from page data
        this.loadVariantMetafields();

        // Initialize with current variant on page load
        this.initializeDescription();
      }

      loadVariantMetafields() {
        const metafieldsElement = document.querySelector(`variant-selects[data-section="${this.sectionId}"] [data-variant-metafields]`);

        if (metafieldsElement) {
          try {
            this.variantMetafields = JSON.parse(metafieldsElement.innerHTML);
          } catch (error) {
            console.error('Error parsing variant metafields:', error);
          }
        }
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      initializeDescription() {
        const variantSelectsElement = document.querySelector(
          `variant-selects[data-section="${this.sectionId}"] [data-selected-variant]`
        );

        if (variantSelectsElement) {
          try {
            const variant = JSON.parse(variantSelectsElement.innerHTML);
            this.updateDescription(variant);
          } catch (error) {
            console.error('Error parsing initial variant data:', error);
          }
        }
      }

      handleVariantChange(event) {
        const { data } = event;

        // Check if this event is for our section
        if (data.sectionId !== this.sectionId) {
          return;
        }

        // Get variant from event data or from updated HTML
        let variant = data.variant;

        if (!variant && data.html) {
          // Try to extract variant from updated HTML
          const variantSelectsElement = data.html.querySelector('variant-selects [data-selected-variant]');
          if (variantSelectsElement) {
            try {
              variant = JSON.parse(variantSelectsElement.innerHTML);
            } catch (error) {
              console.error('Error parsing variant from HTML:', error);
            }
          }
        }

        if (variant) {
          this.updateDescription(variant);
        }
      }

      updateDescription(variant) {
        if (!this.descriptionContainer) {
          return;
        }

        let descriptionHTML = this.fallbackDescription;
        let jsonData = null;

        // Try to get description from variant metafield
        if (variant && variant.metafields && variant.metafields.custom && variant.metafields.custom.json_data) {
          jsonData = variant.metafields.custom.json_data;
        } else if (variant && variant.id && this.variantMetafields[variant.id]) {
          // Fallback: try to get metafields from cached data
          const cachedData = this.variantMetafields[variant.id];
          if (cachedData && cachedData.json_data) {
            jsonData = cachedData.json_data;
          }
        }

        // Parse and extract description
        if (jsonData) {
          try {
            // Handle if jsonData is already an object or needs parsing
            const parsedData = typeof jsonData === 'string' ? JSON.parse(jsonData) : jsonData;

            if (parsedData && parsedData.description) {
              descriptionHTML = parsedData.description;
            }
          } catch (error) {
            console.error('Error parsing variant metafield JSON:', error);
          }
        }

        // Update the description with smooth transition
        this.animateDescriptionUpdate(descriptionHTML);
      }

      animateDescriptionUpdate(newHTML) {
        // Add fade-out class
        this.descriptionContainer.style.opacity = '0';
        this.descriptionContainer.style.transition = 'opacity 0.2s ease-out';

        // Wait for fade-out, then update content and fade-in
        setTimeout(() => {
          this.descriptionContainer.innerHTML = newHTML;

          // Force reflow
          this.descriptionContainer.offsetHeight;

          // Fade in
          this.descriptionContainer.style.opacity = '1';
          this.descriptionContainer.style.transition = 'opacity 0.3s ease-in';
        }, 200);
      }
    }
  );
}
